// Utils
import { isEmailValid } from "utils/email";
import i18n from "utils/i18n";

// Receive string (Ex: bla@bla.com)
// Returns string - error or empty string if validation passed
export const checkEmailInput = email => {
  const isValidEmail = isEmailValid(email);
  if (!email) {
    return i18n.t("Utils.Validations.Email.Empty");
  } else if (!isValidEmail) {
    return i18n.t("Utils.Validations.Email.Invalid");
  } else {
    return "";
  }
};

// Receive string  (Ex: "John")
// Returns boolean - true if there is no error and false if validation failed
export const checkIsRequiredFieldValue = string => {
  if (!string || string.length === 0) {
    return false;
  } else {
    return true;
  }
};

// Receive object  (Ex: { string: "John", val: 2 })
// Returns boolean - true if there is no error and false if validation failed
export const checkStringIsLongerThan = ({ string, val }) => {
  if (!string || string.length < val) {
    return false;
  } else {
    return true;
  }
};

// Receive string (Ex: "password")
// Returns string - error or empty string if validation passed
export const checkPasswordInput = password => {
  if (!password) {
    return i18n.t("Utils.Validations.Password.Empty");
  } else {
    return "";
  }
};
